import React from 'react';
import {createRoot} from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as Sentry from '@sentry/react';
import {Integrations} from '@sentry/tracing';
import axios from 'axios';
import {init} from '@pmf/analytics';

init('sk_76683a0b-6599-42ad-adc1-6dbc01742605', {appName: 'Rendition Client'});

Sentry.init({
    dsn: 'https://67e3be214650457fa3dcc56697d11f05@o1067849.ingest.sentry.io/6061948',
    integrations: [new Integrations.BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
    enabled: process.env.NODE_ENV === 'production',
});

axios.defaults.baseURL = process.env.REACT_APP_BACKEND_BASE_URL;

const container = document.getElementById('root')!;
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
